// Shared "at-least" money formatter for the main dashboard's exposure surfaces (AttackPathsCard,
// /attack-paths AttackPathsDetail, ExposureTrajectoryChart). The trailing "+" reads as "at least
// this much" — exposure figures are floors, not exact sums — so values are floored (not rounded) at
// each magnitude to keep the "+" truthful: $1.96M must show "$1.9M+", never "$2.0M+". Chart axis
// ticks are a scale, not an amount, and keep plain rounding (ransomware charts keep their own).
//
// Pass { suffix: false } for signed amounts (the 30-day movement deltas "+$93K" / "-$45K" and the
// tooltip's Remediating today "-$12K"), which prepend their own +/− and must not also get the
// trailing "+" ("++$93K+"), and for a range's low bound, so the range reads "$80K – $120K+". The value is still floored.
export function fmtMoneyAtLeast(val, { suffix = true } = {}) {
  if (val == null) return '—';
  const n = Number(val);
  if (isNaN(n)) return '—';
  const plus = suffix && n >= 1 ? '+' : '';
  if (Math.abs(n) >= 1_000_000) return `$${(Math.floor(n / 100_000) / 10).toFixed(1)}M${plus}`;
  if (Math.abs(n) >= 1_000) return `$${Math.floor(n / 1_000)}K${plus}`;
  return `$${Math.floor(n).toLocaleString()}${plus}`;
}
